/**
 * Toggles data-scrolled on the homepage's hidden header once the page leaves the top,
 * so its CSS can slide it into view.
 */
const header = document.querySelector('[data-reveal-header]');

if (header) {
  const update = () => header.toggleAttribute('data-scrolled', window.scrollY > 8);
  update();
  window.addEventListener('scroll', update, { passive: true });
}
